'use strict';
import toLower from 'lodash/toLower';
import sevenz from 'pretty-file-icons/svg/7z.svg';
import aac from 'pretty-file-icons/svg/aac.svg';
import ai from 'pretty-file-icons/svg/ai.svg';
import archive from 'pretty-file-icons/svg/archive.svg';
import arj from 'pretty-file-icons/svg/arj.svg';
import audio from 'pretty-file-icons/svg/audio.svg';
import avi from 'pretty-file-icons/svg/avi.svg';
import css from 'pretty-file-icons/svg/css.svg';
import csv from 'pretty-file-icons/svg/csv.svg';
import dbf from 'pretty-file-icons/svg/dbf.svg';
import doc from 'pretty-file-icons/svg/doc.svg';
import dwg from 'pretty-file-icons/svg/dwg.svg';
import exe from 'pretty-file-icons/svg/exe.svg';
import fla from 'pretty-file-icons/svg/fla.svg';
import flac from 'pretty-file-icons/svg/flac.svg';
import gif from 'pretty-file-icons/svg/gif.svg';
import html from 'pretty-file-icons/svg/html.svg';
import iso from 'pretty-file-icons/svg/iso.svg';
import jpg from 'pretty-file-icons/svg/jpg.svg';
import js from 'pretty-file-icons/svg/js.svg';
import json from 'pretty-file-icons/svg/json.svg';
import mdf from 'pretty-file-icons/svg/mdf.svg';
import mp2 from 'pretty-file-icons/svg/mp2.svg';
import mp3 from 'pretty-file-icons/svg/mp3.svg';
import mp4 from 'pretty-file-icons/svg/mp4.svg';
import mxf from 'pretty-file-icons/svg/mxf.svg';
import nrg from 'pretty-file-icons/svg/nrg.svg';
import pdf from 'pretty-file-icons/svg/pdf.svg';
import png from 'pretty-file-icons/svg/png.svg';
import ppt from 'pretty-file-icons/svg/ppt.svg';
import psd from 'pretty-file-icons/svg/psd.svg';
import rar from 'pretty-file-icons/svg/rar.svg';
import rtf from 'pretty-file-icons/svg/rtf.svg';
import svg from 'pretty-file-icons/svg/svg.svg';
import text from 'pretty-file-icons/svg/text.svg';
import tiff from 'pretty-file-icons/svg/tiff.svg';
import txt from 'pretty-file-icons/svg/txt.svg';
import unknown from 'pretty-file-icons/svg/unknown.svg';
import video from 'pretty-file-icons/svg/video.svg';
import wav from 'pretty-file-icons/svg/wav.svg';
import wma from 'pretty-file-icons/svg/wma.svg';
import xls from 'pretty-file-icons/svg/xls.svg';
import xml from 'pretty-file-icons/svg/xml.svg';
import zip from 'pretty-file-icons/svg/zip.svg';
import {getExtension} from '../../../core-utilities/upload-service/FileUtilities';


const icons = {
  aac,
  ai,
  archive,
  arj,
  audio,
  avi,
  css,
  csv,
  dbf,
  doc,
  dwg,
  exe,
  fla,
  flac,
  gif,
  html,
  iso,
  jpg,
  js,
  json,
  mdf,
  mp2,
  mp3,
  mp4,
  mxf,
  nrg,
  pdf,
  png,
  ppt,
  psd,
  rar,
  rtf,
  svg,
  text,
  tiff,
  txt,
  wav,
  wma,
  xls,
  xml,
  zip,
};

export function getIcon(filename) {
  const ext = toLower(getExtension(filename));

  if (ext === 'mov') {
    return video;
  } else if (ext === '7z') {
    return sevenz;
  } else if (icons.hasOwnProperty(ext)) {
    return icons[ext];
  } else if (ext.length > 3) {

    // text Microsoft Office files
    const first3 = ext.substr(0, 3);

    if (icons.hasOwnProperty(first3)) {
      return icons[first3];
    }
  }

  return unknown;
}



// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/file-icons/index.js